/**
 * Toast notification service — DOM-based singleton
 * Remains as a standalone module (not in Zustand) since it's purely visual/DOM.
 */

let container: HTMLDivElement | null = null;

function init() {
  if (container) return;
  container = document.createElement('div');
  container.className = 'toast-container';
  document.body.appendChild(container);
}

function show(message: string, type = 'info', duration = 3000): HTMLDivElement {
  init();
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.textContent = message;
  container!.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(20px)';
    setTimeout(() => toast.remove(), 300);
  }, duration);

  return toast;
}

export const Toast = {
  show,
  success: (message: string) => show(message, 'success'),
  error: (message: string) => show(message, 'error'),
  info: (message: string) => show(message, 'info'),
};
